import React from 'react';
import { MDCDialog } from '../components/mdc-components';

export default class InfoIcon extends React.Component{
    constructor(props){
         super(props)
     }

     onClick(event){
        this.Dialog.show();
     }

     onDialogAccept = () => {
     }

     onDialogCancel = () => {
     }

     render(){
        var cls='content-edit-icon secondary'; 
        if(this.props.cls) cls+= ' ' + this.props.cls;
        let header=this.props.header ? this.props.header : 'Image Instructions';
        if(this.props.active){
            return(
              <div>
                 <div className={cls} onClick={this.onClick.bind(this)} style={this.props.style}>
                    <i className="material-icons">info_outline</i>
                 </div>
                     <MDCDialog
                        ref={(ref) => this.Dialog = ref}
                        onDialogAccept={this.onDialogAccept}
                        onDialogCancel={this.onDialogCancel}
                        accept="Close"
                        header={header}
                     >
                        <div dangerouslySetInnerHTML={{__html: this.props.content}}>
                                
                        </div>
                     </MDCDialog>                
                 {this.props.children}
              </div>  
            );
        }else{
            return(
               <div className="hide"></div>
            );
        }
     }
}